import React, { useCallback } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import Icon from '../Icon'
import Toast from '../Toast'
import styled from 'styled-components'

const CopyBoxStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  .copy-label {
    margin-left: 6px;
    font-weight: 500;
    font-size: 15px;
    line-height: 18px;
    color: inherit;
  }
`
type CopyTextProps = {
  text: string
  label?: string
  className?: string
}
const CopyText = (props: CopyTextProps) => {

  const handleCopy = useCallback(() => {
    Toast({ text: 'Copied' })
  }, [])

  return (
    <CopyToClipboard text={props?.text} onCopy={handleCopy}>
      <CopyBoxStyled className={props?.className}>
        <Icon type="copy"></Icon>
        {props.label ? <span className="copy-label">{props.label}</span> : ''} 
      </CopyBoxStyled>
    </CopyToClipboard>
  )
}

export default CopyText